import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Status, Icon } from '@weezevent/nacre';

import { InfoTextTooltip } from '../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';

import css from './components.module.css';

const SelectedAction = ({ action, status = true, mode = true, handleEdit, handleDelete }) => {
    const { t } = useTranslation();

    return (
        <Card className={css['selected-action-card']}>
            <InfoTextTooltip
                title={action.name}
                subtitle={
                    <span>
                        {`${t('ticket.common.type')}: `}
                        {t(`ticket.moderation.statusesTransitions.transition.steps.actions.${action.type}`)}
                    </span>
                }
            />
            <div>
                {mode && <span className={css['selected-action-status-mode']}>{t(`ticket.moderation.statusesTransitions.actionsTable.${action.mode}`)}</span>}
                {status && <Status responsive text={t(`ticket.moderation.statusesTransitions.actionsTable.status_${action.status}`)} color={action.status_color} />}
                {handleEdit && <Icon className={css['selected-action-status-btn']} name="eye" onClick={() => handleEdit(action)} />}
                {handleDelete && <Icon className={css['selected-action-status-btn']} name="cross" onClick={() => handleDelete(action)} />}
            </div>
        </Card>
    );
};

export default SelectedAction;
